// extracted by mini-css-extract-plugin
export default {"keywords":"ArticleKeywords_keywords__fIstv","item":"ArticleKeywords_item__qg5-E"};